import { getLaborScopeTotalParts } from 'lib/selectors/getScopeTotalParts';
import { getRejectedParts } from 'lib/selectors/getRejectedParts';
import { getScopeNetPartsMade } from 'lib/selectors/getScopeNetPartsMade';
import { createSelector } from 'reselect';
import { getTotalUserAddedManualPartCounts } from './getTotalUserAddedManualPartCounts';
import { getIsApmERPJobFlow } from './getIsApmERPJobFlow';
import { getApmCurrentOrderQuantity } from './getApmCurrentOrderQuantity';

const getProductionPartsDisplay = createSelector(
  [
    getScopeNetPartsMade,
    getRejectedParts,
    getLaborScopeTotalParts,
    getTotalUserAddedManualPartCounts,
    getIsApmERPJobFlow,
    getApmCurrentOrderQuantity,
  ],
  (
    scopeNetPartsMade,
    rejectedParts,
    laborTicketPartsMade,
    totalUserAddedManualPartCounts,
    isApmERPJobFlow,
    apmCurrentOrderQuantity
  ) => {
    if (isApmERPJobFlow && apmCurrentOrderQuantity != null) {
      return {
        displayParts: apmCurrentOrderQuantity.completedQuantity,
        rejectedParts: apmCurrentOrderQuantity.submittedBadParts,
        unsubmittedParts:
          apmCurrentOrderQuantity.uncoveredParts ?? laborTicketPartsMade,
      };
    }

    const displayParts = scopeNetPartsMade + totalUserAddedManualPartCounts;

    return {
      displayParts,
      rejectedParts,
      // Since clock-in — matches Part Count "unsubmitted" and labor form default
      unsubmittedParts: laborTicketPartsMade,
    };
  }
);

export { getProductionPartsDisplay };
